<template>
  <div class="flex flex-col space-y-1" :class="[classes]">
    <LabelReset
      v-if="label"
      :initialValue="initialValue"
      :modelValue="modelValue"
      @update:modelValue="$emit('update:modelValue', $event)"
    >
      {{ label }}
    </LabelReset>
    <input
      type="number"
      class="font-sans placeholder:text-fg-placeholder rounded border-solid border border-linear-subtle px-4 py-2 bg-surface-primary"
      :placeholder="placeholder"
      v-model="localNumber"
      :class="[inputClasses]"
      :disabled="disabled"
      :min="min"
      :max="max"
      :step="step"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import LabelReset from '@/common/components/molecules/LabelReset.vue'

export default defineComponent({
  name: 'NumberInput',
  components: { LabelReset },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    modelValue: {
      type: Number,
      default: 0,
    },
    initialValue: {
      required: false,
      type: Number,
      default: undefined,
    },
    label: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
    },
    classes: {
      type: String,
      required: false,
    },
    inputClasses: {
      type: String,
      required: false,
    },
    currency: {
      type: Boolean,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    min: {
      type: [String, Number],
      required: false,
    },
    max: {
      type: [String, Number],
      required: false,
    },
    step: {
      type: [String, Number],
      required: false,
    },
  },
  data() {
    return {
      localNumber: this.modelValue as number | string,
    }
  },
  watch: {
    modelValue() {
      this.localNumber = this.modelValue
    },
    localNumber() {
      if (this.localNumber === '') {
        this.localNumber = this.min ? +this.min : 0
      }

      if (this.localNumber === this.modelValue) return
      this.$emit('update:modelValue', +this.localNumber)
    },
  },
  mounted() {
    this.localNumber = this.modelValue
  },
  emits: {
    'update:modelValue'(value: number) {
      return typeof value == 'number'
    },
  },
})
</script>
